import { CircleIcon, ExclamationMarkIcon } from '../generated'
import { StackIcons } from '../StackIcons'
import type { PredefinedStackProps } from '../PredefinedStackProps'

export const ExclamationMarkIconStacked = ({ backgroundColor, mainColor, color, ...props }: PredefinedStackProps) => (
  <StackIcons variant="full" {...props}>
    <CircleIcon color={backgroundColor || color} />
    <ExclamationMarkIcon color={mainColor || color} />
  </StackIcons>
)
